export default __webpack_public_path__ + "static/media/witnesses.4cf6f5c4.png";